export const ROOT = "/";
export const DEMOGRAPHIC_SURVEY = "demographic-survey";
export const FEEDBACK = "feedback";

export const MODULES = "modules";
export const CONFIDENCE_SURVEY = "confidence-survey";
export const PRE_MODULE_QUIZ = "pre-module-quiz";
export const MODULE_CONTENT = "module-content";
export const POST_MODULE_GAME = "post-module-game";

export const ENDOMETRIAL_BIOPSY = "endometrial-biopsy";
export const INTRA_UTERINE_DEVICE_INSERTION = "intra-uterine-device-insertion";
export const VULVA_PUNCH_BIOPSY = "vulva-punch-biopsy";
export const ROUTINE_PESSARY_CARE = "routine-pessary-care";
export const PESSARY_FITTING = "pessary-fitting";
export const MEDICAL_ABORTION = "medical-abortion";
export const TRAUMA_INFORMED_EXAMS = "trauma-informed-exams";

export const RATING_INSTRUMENTS = "rating-instruments";
export const IN_SITU_SIMULATION = "in-situ-simulation";
export const VIRTUAL_SIMULATION = "virtual-simulation";
export const OSCE = "osce";
export const CLINICAL_PERFORMANCE = "clinical-performance";
export const GRS = "grs";
export const PSC = "psc";

export const NEW = "new";
export const SEARCH = "search";
export const RESULTS = "results";

export const VIDEOS = "videos";

let thePathsMap: { [x: string]: string } = {};
thePathsMap[DEMOGRAPHIC_SURVEY] = "Demographic Survey";
thePathsMap[MODULES] = "Modules";
thePathsMap[PRE_MODULE_QUIZ] = "Pre-Module Quiz";
thePathsMap[MODULE_CONTENT] = "Module Content";
thePathsMap[POST_MODULE_GAME] = "Post-Module Game";
thePathsMap[ENDOMETRIAL_BIOPSY] = "Endometrial Biopsy/Aspiration";
thePathsMap[INTRA_UTERINE_DEVICE_INSERTION] =
  "Intrauterine Device/System (IUD/IUS) Insertion";
thePathsMap[VULVA_PUNCH_BIOPSY] = "Punch Biopsy of Vulva";
thePathsMap[ROUTINE_PESSARY_CARE] = "Routine Pessary Care";
thePathsMap[PESSARY_FITTING] =
  "Pessary Fitting for Pelvic Organ Prolapse and Stress Urinary Incontinence";
thePathsMap[MEDICAL_ABORTION] = "Medical Abortion";
thePathsMap[RATING_INSTRUMENTS] = "Rating Instruments";
thePathsMap[IN_SITU_SIMULATION] = "In-Situ Simulation";
thePathsMap[VIRTUAL_SIMULATION] = "Virtual Simulation";
thePathsMap[OSCE] = "OSCE";
thePathsMap[CLINICAL_PERFORMANCE] = "Clinical Performance";
thePathsMap[GRS] = "GRS";
thePathsMap[PSC] = "PSC";
thePathsMap[SEARCH] = "Search";
thePathsMap[RESULTS] = "Results";
thePathsMap[NEW] = "New";
thePathsMap[VIDEOS] = "Videos";

export const pathsMap = thePathsMap;

// TODO anything that has pessary fitting should be routine pessary care
